import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigProvider } from '../config/config';
import { AppState } from '../../config/state';
import Typesense from 'typesense';

@Injectable()
export class TypesenseProvider {
  client: any;
  preset: string;
  constructor(public http: HttpClient, private state: AppState, private config: ConfigProvider) {}
  async init() {
    await this.config.load(this.state.appId).then( cfg => {
      const discover = cfg.settings ? cfg.settings.discover : null;
      if(!discover || !discover.nodes || !discover.key || !discover.preset) return;
      const nodes = discover.nodes.map( host => {
        return {host, port: '443', protocol: 'https'};
      });
      this.client = new Typesense.Client({
        nodes,
        apiKey: discover.key,
        connectionTimeoutSeconds: 3
      });
      this.preset = discover.preset;
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/typesense/typesense.ts